var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 0C7.791 0 0 7.78969 0 17.4166C0 17.9348 0.420125 18.3549 0.938375 18.3549H17.4166C17.9348 18.3549 18.3549 17.9348 18.3549 17.4166V0.938375C18.3549 0.420125 17.9348 0 17.4166 0ZM10.7404 21.0679C10.6595 20.9203 10.5405 20.7972 10.3957 20.7114C10.2509 20.6256 10.0857 20.5804 9.91744 20.5804H4.36781C4.22053 20.5804 4.07531 20.6151 3.94392 20.6816C3.81252 20.7482 3.69864 20.8447 3.61148 20.9635C3.52431 21.0822 3.46632 21.2198 3.44219 21.3651C3.41805 21.5103 3.42846 21.6593 3.47256 21.7998C5.24 27.4291 10.3379 31.6144 16.4782 31.9999V24.9662C15.2813 24.8175 14.137 24.3864 13.1394 23.7087C12.1418 23.0309 11.3195 22.1258 10.7404 21.0679ZM21.7998 3.47263C21.6593 3.42848 21.5103 3.41804 21.365 3.44216C21.2197 3.46628 21.0821 3.52427 20.9634 3.61145C20.8446 3.69863 20.7481 3.81254 20.6815 3.94397C20.615 4.07539 20.5803 4.22063 20.5804 4.36794V9.9175C20.5804 10.0858 20.6257 10.2509 20.7114 10.3957C20.7972 10.5405 20.9203 10.6595 21.0679 10.7404C22.1257 11.3196 23.0308 12.1418 23.7086 13.1394C24.3863 14.137 24.8174 15.2814 24.9661 16.4782H31.9999C31.6134 10.3246 27.4158 5.23594 21.7998 3.47263ZM24.9673 18.3549C24.5416 21.8016 21.8017 24.5416 18.3549 24.9673V31.9993C25.677 31.5384 31.5378 25.6869 31.9993 18.3549H24.9673Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsActive);
export default __webpack_public_path__ + "static/media/metricsActive.b9fa53d8fd9247354c1ca4af9bcde322.svg";
export { ForwardRef as ReactComponent };